import { ACCESS_COUNTY_CONTRACTOR_EDIT_BUTTON } from './authConstants';

export const COUNTY_EDIT_CONTRACTOR = {
  id: 'countyEditContractor',
  label: 'Edytuj wykonawcę',
  iconClass: 'fa fa-pencil',
  access: ACCESS_COUNTY_CONTRACTOR_EDIT_BUTTON
};
